import { SELECT_AGENT_SUCCESS } from '@redux/modules/agent';
import { SELECT_OFFICE_SUCCESS } from '@redux/modules/office';

const APP_LOAD = 'APP_LOAD';
const CLAREITY_LOGIN = 'CLAREITY_LOGIN';
const CONDO_MANAGEMENT_PAGE_CLICKED = 'CONDO_MANAGEMENT_PAGE_CLICKED';
const DOMAIN_AUTHENTICATION = 'DOMAIN_AUTHENTICATION';
const HOME_BUTTON_CLICKED = 'HOME_BUTTON_CLICKED';
const LISTINGS_PAGE_CLICKED = 'LISTINGS_PAGE_CLICKED';
const LOAD_FORM_DEFINITION_SUCCESS = 'LOAD_FORM_DEFINITION_SUCCESS';
const LOGIN = 'LOGIN';
const LOGOUT = 'LOGOUT';
const IMPERSONATION_PAGE_CLICKED = 'IMPERSONATION_PAGE_CLICKED';
const OFFICE_PAGE_CLICKED = 'OFFICE_PAGE_CLICKED';
const PROFILE_PAGE_CLICKED = 'PROFILE_PAGE_CLICKED';
const REDIRECT = 'REDIRECT';
const SEARCH_AGENTS_PAGE_CLICKED = 'SEARCH_AGENTS_PAGE_CLICKED';
const SEARCH_LISTINGS_PAGE_CLICKED = 'SEARCH_LISTINGS_PAGE_CLICKED';
const MATRIX_PAGE_CLICKED = 'MATRIX_PAGE_CLICKED';
const REMAPLIST_PAGE_CLICKED = 'REMAPLIST_PAGE_CLICKED';
const CREAWEBFORMS_PAGE_CLICKED = 'CREAWEBFORMS_PAGE_CLICKED';
const CREADDF_PAGE_CLICKED = 'CREADDF_PAGE_CLICKED';
const VIEW_LISTING_CLICKED = 'VIEW_LISTING_CLICKED';
const PROSPECTS_PAGE_CLICKED = 'PROSPECTS_PAGE_CLICKED';
const SPIN_PAGE_CLICKED = 'SPIN_PAGE_CLICKED';
const SPACELIST_PAGE_CLICKED = 'SPACELIST_PAGE_CLICKED';
const CLOUDCMA_PAGE_CLICKED = 'CLOUDCMA_PAGE_CLICKED';
const POSTALCODELOOKUP_PAGE_CLICKED = 'POSTALCODELOOKUP_PAGE_CLICKED';
const RECA_PAGE_CLICKED = 'RECA_PAGE_CLICKED';
const TRAINING_PAGE_CLICKED = 'TRAINING_PAGE_CLICKED';

const initialState = {
  appLoaded: false,
  redirectTo: null,
  showImpersonation: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        appLoaded: true,
      };
    case CLAREITY_LOGIN:
    case LOGOUT:
      return {
        ...state,
        clareityUrl: action.payload.ClareityUrl,
      };
    case CONDO_MANAGEMENT_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/condo',
      };
    case DOMAIN_AUTHENTICATION:
    case LOGIN:
      return {
        ...state,
        redirectTo: action.error ? null : '/',
      };
    case HOME_BUTTON_CLICKED:
      return {
        ...state,
        redirectTo: '/',
      };

    case IMPERSONATION_PAGE_CLICKED:
      return {
        ...state,
        showImpersonation: !state.showImpersonation,
      };
    case LISTINGS_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/listings',
      };
    case LOAD_FORM_DEFINITION_SUCCESS: {
      const { payload } = action;
      const paramDict = {
        listings: 'listingType',
        agent: 'formType',
        office: 'formType',
      };

      const params = `?${paramDict[payload.definitionType]}=${payload.listingType || payload.definitionType}`;
      const url = `/${payload.definitionType}/${payload.operationType}${payload.listingType ? `/${payload.listingType}` : ''}`;
      if (window.location.href.includes(url)) return state;

      return {
        ...state,
        redirectTo: `${url}${params}`,
      };
    }
    case OFFICE_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/office/search',
      };
    case PROFILE_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/agent/view',
      };
    case REDIRECT:
      return {
        ...state,
        redirectTo: null,
        clareityUrl: null,
      };
    case SEARCH_AGENTS_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/agent/search',
      };
    case SEARCH_LISTINGS_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/listings/search',
      };
    case SELECT_AGENT_SUCCESS:
      return {
        ...state,
        redirectTo: '/agent/view',
      };
    case SELECT_OFFICE_SUCCESS:
      return {
        ...state,
        redirectTo: '/office/view',
      };
    case VIEW_LISTING_CLICKED:
      return {
        ...state,
        redirectTo: '/listings/view',
      };
    case MATRIX_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/matrix',
      };
    case REMAPLIST_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/remaplist',
      };
    case CREAWEBFORMS_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/crea/webforms',
      };
    case CREADDF_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/crea/ddf',
      };
    case PROSPECTS_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/prospects',
      };
    case SPIN_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/spin',
      };
    case SPACELIST_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/spacelist',
      };
    case CLOUDCMA_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/cloudcma',
      };
    case POSTALCODELOOKUP_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/resources/postalcodelookup',
      };
    case RECA_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/resources/reca',
      };
    case TRAINING_PAGE_CLICKED:
      return {
        ...state,
        redirectTo: '/resources/training',
      };
    default:
      return state;
  }
};
